/**
 * Pinned canonical slugs per Bókun product id.
 *
 * Products listed here always use ONE URL slug in every language (links,
 * sitemap, canonical). Any other slug ending in the same id — older titles,
 * translated titles, bare ids — 301-redirects to it in a single hop.
 * Only products listed here are affected.
 *
 * Client-safe (no server imports).
 */
export const CANONICAL_TOUR_SLUGS: Readonly<Record<string, string>> = {
  "1237816": "chichen-itza-completo-cenotes-suytun-ik-kil-valladolid-1237816",
};

/** Trailing Bókun id of a slug, or the slug itself when it is a bare id. */
function bokunIdOf(slug: string): string | null {
  const s = slug.trim();
  if (/^\d+$/.test(s)) return s;
  const m = /-(\d+)$/.exec(s);
  return m ? m[1] : null;
}

/** Pinned slug for a product id, if any. */
export function canonicalSlugForId(id: string | null | undefined): string | null {
  return id ? (CANONICAL_TOUR_SLUGS[id] ?? null) : null;
}

/**
 * When `slug` belongs to a pinned product but is not its canonical slug,
 * returns the canonical slug to redirect to. Otherwise null.
 */
export function pinnedSlugRedirect(slug: string): string | null {
  let decoded = slug;
  try {
    decoded = decodeURIComponent(slug);
  } catch {
    /* keep raw */
  }
  const canonical = canonicalSlugForId(bokunIdOf(decoded));
  if (!canonical) return null;
  return decoded === canonical ? null : canonical;
}
